// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";

function RadioIndicator(props) {
  var isSelected = props.isSelected;
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var themeObj = match.themeObj;
  var borderColor = isSelected ? themeObj.colorPrimary : themeObj.borderColor;
  return React.createElement("div", {
              className: "w-4 h-4 rounded-full shrink-0 flex items-center justify-center",
              style: {
                border: "1.5px solid " + borderColor
              }
            }, React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: isSelected,
                  children: React.createElement("div", {
                        className: "w-2 h-2 rounded-full",
                        style: {
                          backgroundColor: themeObj.colorPrimary
                        }
                      })
                }));
}

var make = RadioIndicator;

export {
  make ,
}
/* react Not a pure module */
